import { tryCatchHelper } from '../../../../helpers';
import { ALL_ACTIVIDADES_EXTRAS } from '../actividades_extras/ActividadesExtrasReducer';
import {
  ACTIVO_PLAN_EVALUACION,
  ALL_PLAN_EVALUACION,
  DETALLES_PLAN_EVALUACION,
  LOADING_ALL_PLAN_EVALUACION,
  LOADING_UPDATE_ESTATUS_PLAN_EVALUACION,
} from './PlanEvaluacionReducer';
import {
  allPlanEvaluacionService,
  deletePlanEvaluacionService,
  onePlanEvaluacionService,
  savePlanEvaluacionService,
  updateEstatusPlanEvaluacionService,
} from './PlanEvaluacionService';

export const allPlanEvaluacionAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_PLAN_EVALUACION, payload: true });
    const res = await allPlanEvaluacionService(params);
    dispatch({ type: ALL_PLAN_EVALUACION, payload: res.data });
    dispatch({ type: LOADING_ALL_PLAN_EVALUACION, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_PLAN_EVALUACION, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const savePlanEvaluacionAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await savePlanEvaluacionService(id, data);
    notify(res.data.message);
    await allPlanEvaluacionAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const updateEstatusPlanEvaluacionAction = async (
  { dispatch, notify },
  id,
  data,
  params,
  isActivo = false,
) => {
  dispatch({ type: LOADING_UPDATE_ESTATUS_PLAN_EVALUACION, payload: true });

  try {
    const res = await updateEstatusPlanEvaluacionService(id, data);
    notify(res.data.message);
    await allPlanEvaluacionAction(dispatch, params);
    if (isActivo) setActivoPlanEvaluacionAction(dispatch, res.data.data);
    dispatch({
      type: LOADING_UPDATE_ESTATUS_PLAN_EVALUACION,
      payload: false,
    });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_PLAN_EVALUACION, payload: false });
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoPlanEvaluacionAction = async (dispatch, data) => {
  dispatch({
    type: ALL_ACTIVIDADES_EXTRAS,
    payload: {
      data: [],
      pagination: {},
    },
  });
  dispatch({ type: ACTIVO_PLAN_EVALUACION, payload: data });
};

export const setDetallesPlanEvaluacionAction = async (dispatch, key, value) => {
  try {
    const data = {
      deleteTema: false,
      deleteEvaluacion: false,
      deleteActividad: false,
    };
    const res = {
      ...data,
      [key]: value,
    };
    dispatch({
      type: DETALLES_PLAN_EVALUACION,
      payload: key && value ? res : data,
    });
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const onePlanEvaluacionAction = async (dispatch, id) => {
  try {
    const res = await onePlanEvaluacionService(id);
    await setActivoPlanEvaluacionAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deletePlanEvaluacionAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deletePlanEvaluacionService(id);
    notify(res.data.message);
    await setActivoPlanEvaluacionAction(dispatch, null);
    await allPlanEvaluacionAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
